import {

    FaHome,

    FaPlus,

    FaTools,

    FaMoneyBillWave,

} from "react-icons/fa";

import styles from "./BottomNavigation.module.css";

const BottomNavigation = ({

    active = "home",

    onHome,

    onCars,

    onCreate,

    onMore,

}) => {

    return (

        <nav className={styles.container}>

            <button

                type="button"

                className={`${styles.item}

                ${active === "home"

                    ? styles.active

                    : ""}`}

                onClick={onHome}

            >

                <span className={styles.icon}>

                    <FaHome />

                </span>

                <span className={styles.label}>

                    خانه

                </span>

            </button>

            <button

                type="button"

                className={`${styles.item}

                ${active === "cars"

                    ? styles.active

                    : ""}`}

                onClick={onCars}

            >

                <span className={styles.icon}>

                    <FaTools />

                </span>

                <span className={styles.label}>

                    سرویس ها

                </span>

            </button>

            <button

                type="button"

                className={styles.fab}

                onClick={onCreate}

                aria-label="ثبت جدید"

            >

                <FaPlus />

            </button>

            <button

                type="button"

                className={`${styles.item}

                ${active === "more"

                    ? styles.active

                    : ""}`}

                onClick={onMore}

            >

                <span className={styles.icon}>

                    <FaMoneyBillWave />

                </span>

                <span className={styles.label}>

                    هزینه ها

                </span>

            </button>

        </nav>

    );

};

export default BottomNavigation;